import { render, staticRenderFns } from "./UserAirNotifications.vue?vue&type=template&id=38a94aa2&scoped=true&"
import script from "./UserAirNotifications.vue?vue&type=script&lang=js&"
export * from "./UserAirNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a94aa2",
  null
  
)

export default component.exports